export type LogoVariant = 'light' | 'dark';

const TENANT_ASSETS_BASE_URL = "https://s3.us-east-1.amazonaws.com/biddify.tenant.assets"

export function getTenantLogoUrl(tenantId: string, variant: LogoVariant): string | null {
  return getTenantAssetUrl(tenantId, `nav-logo-${variant}`);
}

export function getTenantAssetUrl(tenantId: string, asset: string): string | null {
  if (!tenantId) return null;
  return `${TENANT_ASSETS_BASE_URL.replace(/\/$/, '')}/${tenantId}/${asset}`;
}